export default __webpack_public_path__ + "static/pic4-776f9f8b5b28bb8a1df33bc7bc409b8b.jpg";